module.exports = __webpack_public_path__ + "img/marketinsight.fde83cd7.svg";